import { shouldUseExplicitLogonAttachmentRouting } from 'owa-account-shared-mailbox-utils';
import type { MailboxInfo } from 'owa-client-types';
import setExplicitLogonHeaders from 'owa-headers/lib/setExplicitLogonHeaders';

export function getExplicitLogonAttachmentHeaders(
    mailboxInfo: MailboxInfo,
    additionalHeaders?: Headers
): Headers | undefined {
    if (!shouldUseExplicitLogonAttachmentRouting(mailboxInfo)) {
        return undefined;
    }

    const headers = additionalHeaders ?? new Headers();
    setExplicitLogonHeaders(
        mailboxInfo.mailboxSmtpAddress,
        headers,
        mailboxInfo.mailboxPrefixedIdentity ?? undefined
    );
    return headers;
}
